import { render, staticRenderFns } from "./CompanyAdmin.vue?vue&type=template&id=36794d0e"
import script from "./CompanyAdmin.vue?vue&type=script&lang=js"
export * from "./CompanyAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports